<div class="my-4" *ngIf="showComplianceMessage && checkComplianceConfig">
    <div class="d-flex justify-content-between align-items-center infoBoxStyle mt-3">
        <div class="d-flex">
            <img class="img imgAlignment" src={{imgSrc}} />
            <span class="m-3 infoClass text-break">{{complianceInfo}}</span>
            <br/>
        </div>
    </div>
</div>